module.exports = __webpack_public_path__ + "img/icon-units.d5043291.svg";